<template>
  <div style="position: relative">
    <iframe v-if="this.version!=''" id="baidutongji" name="baidutongji"
        :src="`https://aiplugin.5118.com/Pluginstat/?p=checkprohibitedwords&v=${version}`"
        style="width: 0; height: 0; position: fixed; transform: translateY(-9999px);"></iframe>
    <div dir="rtl" class="page" style="height: 100%;">
      <div dir="ltr">
        <p class="checkdomainname" :title="getdomain">当前域名【{{getdomain}}】</p>
        <div class="row" style="margin: 10px 0;">
          <div class="col-15 left">
            <button class="btn" @click="checkProhibitedWords" :disabled="loading">{{loading?"查询中...":"点击查违规词"}}</button>
          </div>
          <div class="col-15 right">

          </div>
        </div>
        <div class="line" style="margin-bottom: 15px;"></div>

        <RadioGroup v-if="this.isListShow" v-model="filterType">
          <Radio value="AD" :label="`广告词违规(${isADNum})`" style="width: 50%;"></Radio>
          <Radio value="Polity" :label="`违规敏感词(${isBadNum})`" style="width: 50%;"></Radio>
        </RadioGroup>

        <table v-if="this.isListShow" class="table" style="table-layout: fixed">
          <thead>
          <tr>
            <th>违规词</th>
            <th>类型</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in getItems(items)" :key="index">
            <td style="cursor: pointer;" @click="checknextkeywords(item.Keyword)">{{item.Keyword}}<span v-if="item.RepeatCount>1">({{item.RepeatCount}})</span></td>
            <td :title="item.IsSure=='确定'?item.Desc:item.IsSure" :style="{color:item.IsSure==='可疑'?`rgb(238, 147, 11)`:`red`}">{{item.IsSure=="确定"?item.Desc:item.IsSure}}</td>
          </tr>
          </tbody>
        </table>
        <p v-if="isShow" style="font-size: 13px;color:green;">
          <strong>未发现违规词，请继续保持！</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex"
  import RadioGroup from "../components/form/RadioGroup"
  import Radio from "../components/form/Radio"

  export default {
    name: "ProhibitedWords",
    data() {
      return {
        repeatcount:0
      }
    },
    components: {
      RadioGroup,
      Radio
    },
    computed: {
      filterType: {
        get() {
          return this.$store.state.prohibitedWords.filterType
        },
        set(val) {
          return this.$store.state.prohibitedWords.filterType = val
        }
      },
      isADNum: {
        get() {
          return this.$store.state.prohibitedWords.isADNum
        },
        set(val) {
          return this.$store.state.prohibitedWords.isADNum = val
        }
      },
      isBadNum: {
        get() {
          return this.$store.state.prohibitedWords.isBadNum
        },
        set(val) {
          return this.$store.state.prohibitedWords.isBadNum = val
        }
      },
      items: {
        get() {
          return this.$store.state.prohibitedWords.items
        },
        set(val) {
          return this.$store.state.prohibitedWords.items = val
        }
      },
      loading: {
        get() {
          return this.$store.state.prohibitedWords.loading
        },
        set(val) {
          return this.$store.state.prohibitedWords.loading = val
        }
      },
      isShow: {
        get() {
          return this.$store.state.prohibitedWords.isShow
        },
        set(val) {
          return this.$store.state.prohibitedWords.isShow = val
        }
      },
      isListShow:{
        get() {
          return this.$store.state.prohibitedWords.isListShow
        },
        set(val) {
          return this.$store.state.prohibitedWords.isListShow = val
        }
      },
      checkkeywordscount:{
        get() {
          return this.$store.state.prohibitedWords.checkkeywordscount
        },
        set(val) {
          return this.$store.state.prohibitedWords.checkkeywordscount = val
        }
      },
      iscount:{
        get() {
          return this.$store.state.prohibitedWords.iscount
        },
        set(val) {
          return this.$store.state.prohibitedWords.iscount = val
        }
      },
      checkkeywords:{
        get() {
          return this.$store.state.prohibitedWords.checkkeywords
        },
        set(val) {
          return this.$store.state.prohibitedWords.checkkeywords = val
        }
      },
      version:{
        get(){
          return this.$store.state.menu.version
        },
        set(val){
          this.$store.state.menu.version = val
        }
      },
      getdomain: {
        get() {
          return this.$store.state.menu.jump_domain_url;
        }
      }
    },
    mounted() {
      this.ASetHistory("prohibitedwords").then(flag => {
        if (flag) {
          this.listenProhibitedWords();
        }
      });
    },
    methods: {
      ...mapActions("menu", ["ASetHistory"]),
      checkProhibitedWords() {
        if (this.loading) {
          return;
        }
        // _hmt.push(['_trackEvent', 'Prohibitedwords', 'Check']);
        this.items = [];
        this.isADNum = 0;
        this.isBadNum = 0;
        this.isShow = false;
        this.$messenger.addTarget(window.parent, 'parent');
        this.$messenger.targets['parent'].send("Check-Prohibited-Words");
        this.loading = true;
      },
      checknextkeywords(keyword){
        if(keyword!=this.checkkeywords)
        {
          this.iscount=1;
          this.checkkeywordscount=0;
          this.checkkeywords=keyword;
          // console.log('当前第:'+this.iscount);
          let sendmsg={'keywords':keyword,'nextnum':this.iscount}
          this.$messenger.addTarget(window.parent, 'parent');
          this.$messenger.targets['parent'].send("Check-Next-Keywords",sendmsg);
          // console.log('checkkeywordscount:'+this.checkkeywordscount);
          if(this.iscount!=1)
          {
            if(this.iscount>=this.checkkeywordscount)
            {
              this.iscount=0;
            }
          }
        }
        else
        {
          this.iscount+=1;
          this.checkkeywords=keyword;
          // console.log('当前第:'+this.iscount);
          let sendmsg={'keywords':keyword,'nextnum':this.iscount}
          this.$messenger.addTarget(window.parent, 'parent');
          this.$messenger.targets['parent'].send("Check-Next-Keywords",sendmsg);
          // console.log('checkkeywordscount:'+this.checkkeywordscount);
          if(this.iscount!=1)
          {
            if(this.iscount>=this.checkkeywordscount)
            {
              this.iscount=0;
            }
          }
        }

      },
      getItems(items){

          return items.filter((item)=>{
            return item.Type === this.filterType;
          })
      },
      listenProhibitedWords() {
        this.$messenger.listen("_5118_ProhibitedWords_Info", (msg) => {
          if (msg && msg.length) {
            for (let item of  msg) {
              item['Type']==="AD"?this.isADNum+=1:this.isBadNum+=1;
              this.$store.state.prohibitedWords.items.push(item)
              this.items.reverse();
            }
            this.items.sort((a, b)=> b.IsSure.localeCompare(a.IsSure, 'zh'))
          }
          else
          {
            this.isShow=true;
          }
        });
        this.$messenger.listen("_5118_ProhibitedWords_End", (msg) => {
          if (msg === "End") {
            this.isListShow=true;
            this.loading = false;
          }
        });
        this.$messenger.listen("_5118_ProhibitedWords_keywordscount", (msg) => {
          this.checkkeywordscount=msg;
          // console.log('返回数据：'+this.checkkeywordscount);
        });
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .table {
    width: 100%;
    border: none;

    td, th {
      border: none;
      text-align: left;
      line-height: 26px;
      font-size: 12px;
      font-weight: normal;
      .ellipsis();
      &:nth-child(1) {
        width: 70%;
      }
      &:nth-child(2) {
        width: 30%;
      }
    }
    tbody{
      tr{
        &:hover{
          background-color: #e6e6e6
        }
      }
    }
    td {
      &:nth-child(1) {
        color: @theme-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ProhibitedWords.vue